const TIER_LABELS: Record<string, string> = {
  DEVELOPMENT: "Dev",
  "gb-nhs-uat": "UAT",
  "gb-nhs-staging": "Staging",
};

export function getEnvironmentLabel(): string | null {
  const appEnvironment = import.meta.env.APP_ENVIRONMENT;
  return appEnvironment ? TIER_LABELS[appEnvironment] ?? null : null;
}
